import React, {Component} from 'react'
import {Form, Input, Select, Header, Icon, Popup} from 'semantic-ui-react'
import Calendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import moment from 'moment';
import 'rc-calendar/assets/index.css';

const options = [
    {key: 'm', text: 'Male', value: 'Male', icon: 'male'},
    {key: 'f', text: 'Female', value: 'Female', icon: 'female'},
]
const now = moment();

function getFormat(time) {
    return 'MM/DD/YYYY';
}

const defaultCalendarValue = now.clone();
defaultCalendarValue.add(-18, 'year');

class AccountInformation extends Component {


    constructor(props) {
        super(props)
        this.state = {
            selectedGender: props.data.gender || "",
            defaultCalendarValue: defaultCalendarValue,
            date_of_birth: props.data.date_of_birth || defaultCalendarValue
        }
    }

    handleChange = (e) => {
        this.props.change(e.target.name, e.target.value)
    }

    handleGenderChange = (e, {value}) => {
        this.setState({selectedGender: value})
        this.props.change('gender', value)
    }

    onChange = (value) => {
        this.setState({date_of_birth: value})
        this.props.change('date_of_birth', value)
    }

    render() {

        let calendar = (<Calendar
            style={{zIndex: 1000}}
            dateInputPlaceholder="please input"
            formatter={getFormat(false)}
            showDateInput={true}
            defaultValue={this.state.defaultCalendarValue}
        />)
        return (
            <div><Header as='h3' dividing>
                <Icon name='info circle'/>
                <Header.Content>
                    Account Information
                    <Header.Subheader>
                        Manage your Account Information
                    </Header.Subheader>
                </Header.Content>
            </Header>
                <Form.Field control={Input} label='First name' placeholder='First name'
                            value={this.props.data.first_name}
                            name='first_name' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Input} label='Last name' placeholder='Last name' value={this.props.data.last_name}
                            name='last_name' onChange={this.handleChange.bind(this)}/>
                <DatePicker
                    animation="slide-up"
                    calendar={calendar}
                    value={this.state.date_of_birth}
                    disabled={false}
                    onChange={this.onChange}
                >
                    {
                        ({value}) => {
                            return (
                                <Form.Field control={Input} label='Date of Birth' placeholder='Date of Birth'
                                            value={value.format(getFormat(false)) || ''}
                                            name='date_of_birth'/>
                            );
                        }
                    }
                </DatePicker>

                <Form.Field control={Input} label='Email Address' placeholder='Email Address'
                            value={this.props.data.email}
                            name='email' onChange={this.handleChange.bind(this)}/>
                <Form.Field control={Select} label='Gender' options={options} placeholder='Gender'
                            value={this.state.selectedGender}
                            name='gender' onChange={this.handleGenderChange.bind(this)}/>
                <Form.Field>
                    <label>Password <Popup size='tiny' basic trigger={<Icon size='small' circular fitted name='help' />} content='A password must contain 1 lowercase letter, 1 uppercase letter, 1 number, and be at least six characters long.' /></label>
                    <Input placeholder='Password' type='password'
                           value={this.props.data.password}
                           name='password' onChange={this.handleChange.bind(this)} />
                </Form.Field>

                <Form.Field>
                    <label>Confirm Password <Popup size='tiny' basic trigger={<Icon size='small' circular fitted name='help' />} content='A password must contain 1 lowercase letter, 1 uppercase letter, 1 number, and be at least six characters long.' /></label>
                    <Input placeholder='Confirm Password'
                           value={this.props.data.confirm_password}
                           name='confirm_password' onChange={this.handleChange.bind(this)} type='password' />
                </Form.Field>
                {/*<Form.Field control={Input} label='Password' placeholder='Password' type='password'*/}
                            {/*value={this.props.data.password}*/}
                            {/*name='password' onChange={this.handleChange.bind(this)}/>*/}
                {/*<Form.Field control={Input} label='Confirm Password' placeholder='Confirm Password'*/}
                            {/*value={this.props.data.confirm_password}*/}
                            {/*name='confirm_password' onChange={this.handleChange.bind(this)} type='password'/>*/}

            </div>
        )
    }
}

export default AccountInformation


// WEBPACK FOOTER //
// ./src/containers/register/AccountInformation.js